import {
  CaptionsAnimationConfig,
  CaptionsRendererConfig,
} from '@sparemin/text-effects';
import { indexBy } from 'underscore';

import {
  createCaptionCueObject,
  getDefaultCaptionWordStyling,
} from 'utils/caption-adv-animation';

import { KARAOKE_ANIMATION_NAMES } from './constants';
import {
  AnimationConfigGetterParams,
  AnimationKey,
  AnimationModule,
} from './types';

export const checkIsKaraokeAnimation = (
  selectedAdvancedAnimation: CaptionsAnimationConfig,
): boolean => {
  return KARAOKE_ANIMATION_NAMES.includes(
    selectedAdvancedAnimation?.animationName,
  );
};

export const getAnimationChildView = (
  selectedAdvancedAnimation: CaptionsAnimationConfig,
  animationModules: AnimationModule[],
): React.ReactNode => {
  if (!selectedAdvancedAnimation?.enabled) {
    return null;
  }

  const animationModulesAsObject = indexBy(animationModules, 'key') as Record<
    AnimationKey,
    AnimationModule
  >;

  if (checkIsKaraokeAnimation(selectedAdvancedAnimation)) {
    return animationModulesAsObject?.karaoke?.contents;
  }

  return animationModulesAsObject[selectedAdvancedAnimation?.animationName]
    ?.contents;
};

export const getAdvancedAnimationPreviewConfig = (
  config: AnimationConfigGetterParams,
  paused?: boolean,
): CaptionsRendererConfig => {
  const {
    advancedAnimation,
    boxSize,
    canvasSize,
    textStyles,
    textValue,
  } = config;
  const hasCanvasDims = !!(canvasSize?.width && canvasSize?.height);

  return {
    cues: advancedAnimation?.enabled ? [createCaptionCueObject(textValue)] : [],
    textStyles,
    animationConfig: advancedAnimation?.enabled
      ? {
          ...advancedAnimation,
          enabled: paused ? false : advancedAnimation?.enabled,
          properties: {
            ...advancedAnimation.properties,
            wordActiveColor:
              advancedAnimation.animationName !== 'activeWordColor'
                ? textStyles?.color
                : advancedAnimation.properties?.wordEmphasisColor,
            wordFutureColor: advancedAnimation.properties?.wordFutureColor,
            wordPastColor: textStyles?.color,
            lineActiveColor: textStyles?.color,
            lineFutureColor: advancedAnimation.properties?.lineFutureColor,
            lineBackgroundColor:
              advancedAnimation.properties?.lineBackgroundColor,
            lineBackgroundRadius:
              advancedAnimation.properties?.lineBackgroundRadius,
          },
        }
      : undefined,
    ...(hasCanvasDims && { canvasDims: canvasSize }),
    ...(boxSize?.height && { cueOpts: { height: boxSize.height } }),
    ...getDefaultCaptionWordStyling(canvasSize?.width),
  };
};
